import Tippy from "@tippyjs/react"
import * as React from "react"
import "tippy.js/dist/tippy.css"
import "tippy.js/themes/light-border.css"

const BylineBox = ({ name, authorData }) => {
  return (
    <div className="bylineBox">
      <header>
        <img
          src={authorData.image.formats.thumbnail.url}
          alt=""
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: "0.5em",
          }}
        >
          <h3>{name}</h3>
          <h5>{authorData.jobTitle}</h5>
        </div>
      </header>
      <p>{authorData.shortBio}</p>
    </div>
  )
}

const Byline = ({ byline, authors, published_at }) => (
  <div className="row">
    <div className="col-12 byline">
      {byline.length > 0 && (
        <p>
          by{" "}
          {byline.map((bl, idx) => {
            const isFirst = idx === 0
            const isLast = idx === byline.length - 1
            const isMiddle = !(isFirst || isLast)
            let connector = ""
            if (isFirst) {
              connector = ""
            } else if (isLast) {
              connector = " and"
            } else if (isMiddle) {
              connector = ","
            }
            const authorData = authors.edges?.find(
              edge => edge.node.user.id === bl.id
            )
            return (
              <span key={bl.id}>
                {connector}{" "}
                {authorData ? (
                  <Tippy
                    content={
                      <BylineBox
                        name={`${bl.firstname} ${bl.lastname}`}
                        authorData={authorData.node}
                      />
                    }
                    hideOnClick={false}
                    theme="light-border"
                    placement="bottom-start"
                    allowHTML={true}
                    // interactive={true}
                  >
                    <span className="author">
                      {bl.firstname} {bl.lastname}
                    </span>
                  </Tippy>
                ) : (
                  <span className="author">
                    {bl.firstname} {bl.lastname}
                  </span>
                )}
              </span>
            )
          })}
          <span className="published">Published {published_at}</span>
        </p>
      )}
    </div>
  </div>
)

export default Byline
